var tm = "";

function getLocalDateTimeISO() {
    const now = new Date();
    const offset = -now.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const pad = (num, size = 2) => String(num).padStart(size, '0');

    return `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())} (${sign}${pad(Math.floor(Math.abs(offset)/60))}:${pad(Math.abs(offset)%60)} GMT)`
}

function getWorldTime() {
    try {
        fetch("https://worldtimeapi.org/api/ip")
    .then(res => res.json())
    .then(data => tm = data.utc_datetime);
        } catch (error) {
            console.warn('Time sync failed, using local time');
    }
}

function wireBMOSubmit() {   
    $('#pardot-form').submit(function(e){
        let CRLF = "\n";
        let desc = $('.Description input').val();
        let additional_details = "";
        if ($('.Preferred_contact_method').length)
            additional_details += "Preferred contact method: " + $('.Preferred_contact_method select option:selected').text() + " "+ CRLF ;
        if ($('.Hardware_Platforms').length)
            additional_details += "Hardware platforms : " + $('.Hardware_Platforms select option:selected').text() + " "+ CRLF ;
        if ($('.Licence_Type').length)
            additional_details += "Licence type : " + $('.Licence_Type select option:selected').text() + " "+ CRLF ;
        if ($('.Instructors_Allowed').length)
            additional_details += "Instructors logins needed: " + $('.Instructors_Allowed input').val() + " "+ CRLF ;
        //if ($('.vinyl_pcs_signs input:checked').length)
        if ($('.vinyl_pcs_signs').length)
            additional_details += "Bulk pricing inquiry : " + $('.vinyl_pcs_signs select option:selected').text() + " "+ CRLF ;
            //additional_details += "Bulk pricing inquiry: " + $('.vinyl_pcs_signs input:checked').next('label').text().trim() + " " + CRLF ;
        if ($('.licence_type_orgs').length)
            additional_details += "License Type : " + $('.licence_type_orgs select option:selected').text() + " "+ CRLF ;
        
        //.vinyl_pcs_signs
        if (tm == "") {
            tm = getLocalDateTimeISO();
        }
        let full_value = desc + ' ' + additional_details + 'Submission Datetime:' + tm + " "+ CRLF;
        $('.Description input').val(full_value);
    });
}

function wireSubmissionDateTimeSubmit() {   
    $('#pardot-form').submit(function(e){
        let CRLF = "\n";
        let desc = $('.Description input').val();

        if (tm == "") {
            tm = getLocalDateTimeISO();
        }
        let full_value = desc + ' ' + 'Submission Datetime:' + tm + " "+ CRLF;
        $('.Description input').val(full_value);
    });
}

function sendHeight() {
    const height = document.body.scrollHeight;
    window.parent.postMessage({
        type: 'iframeHeight',
        height: height
    }, '*'); // Use specific domain in production instead of '*'
}

function wireSendHeight() {    
    // Send height when loaded
    window.addEventListener('load', sendHeight);

    // Send height when content changes
    window.addEventListener('resize', sendHeight);

    // If content changes dynamically
    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true
    });
}

